import useInterceptor from "./interceptor";
import useStoreConfig from "./redux";
import useKeycloak from "./keycloak";

const useConfig = () => {
  return {
    useInterceptor,
    useStoreConfig,
    useKeycloak,
  };
};

export default useConfig;
